<template>
  <div class="page">
    <el-card>
      <div slot="header">Settings</div>
      <el-alert title="Chưa có nội dung" type="info" :closable="false" show-icon />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SettingsView'
}
</script>

<style scoped>
.page {
  padding: 16px;
}
</style>




// WEBPACK FOOTER //
// src/views/settings/index.vue